import { render } from "./objects.vue?vue&type=template&id=4c70edb1&ts=true"
import script from "./objects.vue?vue&type=script&lang=ts"
export * from "./objects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__